import { render, staticRenderFns } from "./EditInfomation.vue?vue&type=template&id=16e964de&scoped=true"
import script from "./EditInfomation.vue?vue&type=script&lang=js"
export * from "./EditInfomation.vue?vue&type=script&lang=js"
import style0 from "./EditInfomation.vue?vue&type=style&index=0&id=16e964de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e964de",
  null
  
)

export default component.exports